import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import { useTranslation } from "react-i18next";

export const WarehouseUserSettingsCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // const solved = props.skeleton ? false : props.row.solved ?? false;
    // const solvedText = solved ? "Solved" : "Not solved";
    // const solvedColor = solved ? "green" : "red";

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box display={"flex"} width={props.skeleton ? "50%" : null} flexDirection={"column"}>
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/>
                            :
                            <>
                                <Text bold>{props.name}</Text>
                                {props.admin ?
                                    <Text light variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{props.email}</Text>
                                : 
                                    <Text light variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{props.userPrivileges?.length ?? "0"} {t("rights")}</Text>
                                }
                            </>
                        }
                    </Box>

                </Box>
            </Box>
        </BaseCard>
    )
}
